// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1311":"a04359315385d583","3303":"ed09850f73bd80c1","4001":"d9d6459905499e8c"}[chunkId] + ".js";
};